/**
 * The pages that anyone can read, signed in or out, outside the app shell. The
 * root layout renders them before it mounts session or household queries (#84),
 * the service worker never opens a tapped alert in them, and the sitemap lists
 * them. A test in `tests/discovery.test.ts` holds each one to a route.
 */
export const STANDALONE_PAGES = ["/compare", "/privacy", "/support", "/terms"] as const;

/** Whether a route renders outside the app shell. */
export function isStandalonePage(routeId: string | undefined): boolean {
  return (STANDALONE_PAGES as readonly (string | undefined)[]).includes(routeId);
}
